import React from "react";
import AppointmentForm from "../../AppointmentForm";
const contactInfo = [
  { title: "Contact Us", subTitle: "+91 3614516663, +91 9707076232, +91 9707998887" },
  { title: "Email Us", subTitle: "info@nhwm.in" },
  { title: "Our Location", subTitle: "Hengrabari, Guwahati, Assam" },
];

export default function AppointmentWithContactInfoSection() {

  return (
    <div className="container">
      <div className="row md:ml-[20px] ml-[0]">
        <div className="col-lg-7">
          <h2 className="cs_fs_40 cs_medium mb-0">
            Register to Avail All the Benefits
          </h2>
          <div className="cs_height_42 cs_height_xl_25" />
          <AppointmentForm />
        </div>
        <div className="col-lg-4 offset-lg-1">
          <div className="cs_height_lg_100" />
          <h2 className="cs_fs_40 cs_medium mb-0">Contact Info</h2>
          <div className="cs_height_60 cs_height_xl_40" />
          <ul className="cs_contact_info cs_style_1 cs_mp0">
            {contactInfo.map((item, index) => (
              <li key={index}>
                <h3 className="cs_fs_24 cs_semibold mb-0">{item.title}</h3>
                <p className="mb-0 cs_heading_color">{item.subTitle}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
